import React from 'react'
import { connect } from 'react-redux'

class AppBanner extends React.Component {
  componentDidMount() {
    let counter = 0

    const loadAppBanner = setInterval(() => {
      const appBanner = document.getElementById('branch-banner-iframe')
      if (appBanner) {
        clearInterval(loadAppBanner)
        this.handleBranchAppBanner()
        return
      }
      if (counter > 10) {
        clearInterval(loadAppBanner)
      }
      counter = counter + 1
    }, 1000)
  }

  componentDidUpdate(prevProps) {
    if (JSON.stringify(prevProps.user) !== JSON.stringify(this.props.user)) {
      const appBanner = document.getElementById('branch-banner-iframe')
      if (appBanner) {
        this.handleBranchAppBanner()
      }
    }
  }

  handleBranchAppBanner = () => {
    const { user } = this.props
    if (user && user.role === 'patient') {
      this.showBranchAppBanner()
      return
    }

    this.hideBranchAppBanner()
  }

  hideBranchAppBanner = () => {
    document.getElementById('branch-banner-iframe').style.display = 'none'
  }

  showBranchAppBanner = () => {
    document.getElementById('branch-banner-iframe').style.display = 'block'
  }

  render() {
    return null
  }
}

const mapStateToProps = state => ({
  user: state.auth.user
})

export default connect(mapStateToProps)(AppBanner)
